import keycloakRoles, {
    type KeycloakRoleSnapshot,
} from '../../services/auth/keycloak-roles.service';
import { localDevAuthBypass } from '../../services/auth/localDevAuthBypass';

export const AI_OBSERVABILITY_ACCESS = 'AI_OBSERVABILITY' as const;
export const WORKER_CHAT_ACCESS = 'WORKER_CHAT' as const;
export const AI_OBSERVABILITY_CLIENT_ROLES = [
    'recruitment-view-sessions',
    'recruitment-manage-sessions',
] as const;

export type AiObservabilityAccessState = 'checking' | 'allowed' | 'denied';

export const canAccessAiObservability = (
    snapshot: KeycloakRoleSnapshot,
): boolean =>
    snapshot.realmRoles.includes('admin')
    && AI_OBSERVABILITY_CLIENT_ROLES.some((role) => snapshot.clientRoles.includes(role));

export const canAccessWorkerChat = (snapshot: KeycloakRoleSnapshot): boolean =>
    canAccessAiObservability(snapshot) && snapshot.clientRoles.includes('recruitment-manage-settings');

export const resolveAiObservabilityAccess = async (requireManageSettings = false): Promise<boolean> =>
    localDevAuthBypass() || (requireManageSettings ? canAccessWorkerChat : canAccessAiObservability)(await keycloakRoles.getRoleSnapshot('recruitment-app'));
